export default __webpack_public_path__ + "static/media/a011-PPII-6.a0ee28d3.svg";